module.exports = __webpack_public_path__ + "static/media/mark1.d0786c8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mark1.png
// module id = 1990
// module chunks = 0